export const JOIN_REQUEST_ALREADY_SENT_ERROR = 'JoinRequestAlreadySent';

interface GetDriverLabelProps {
  name?: string;
  email?: string;
}

export function getDriverLabel({ name, email }: GetDriverLabelProps) {
  return name ? name : email ? email : '';
}
